var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33.36 33.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls999-1 {\n        fill: #9fbfe5;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls999-1",
    d: "M30.56,27.97l-1.27-3.82c-.07-.22-.05-.45.06-.66.96-1.86,1.35-4.05.94-6.37-.63-3.55-3.23-6.49-6.6-7.62.87,2.1,1.13,4.43.7,6.75-.88,4.7-4.65,8.43-9.37,9.28-.61.11-1.23.16-1.84.18,1.43,1.55,3.35,2.65,5.49,3.03,2.3.41,4.48.03,6.34-.91.2-.1.44-.13.65-.05l3.83,1.28c.65.22,1.29-.42,1.07-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls999-1",
    d: "M10.95,4.22c-3.98.74-7.17,3.97-7.89,7.96-.41,2.31-.02,4.51.94,6.37.11.2.13.44.06.66l-1.27,3.82c-.22.67.41,1.31,1.09,1.09l3.83-1.28c.22-.07.45-.05.65.05,1.85.94,4.04,1.33,6.34.91,3.98-.71,7.2-3.9,7.95-7.87,1.3-7-4.71-13.01-11.7-11.71ZM13.48,17.1h-4.95c-.49,0-.88-.4-.88-.88s.4-.88.88-.88h4.95c.49,0,.88.4.88.88.01.48-.39.88-.88.88ZM17.02,13.56h-8.49c-.49,0-.88-.4-.88-.88s.4-.88.88-.88h8.49c.49,0,.88.4.88.88.01.49-.39.88-.88.88Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBlue);
export default __webpack_public_path__ + "static/media/chat-blue.68e182e5902d8f5a67abc2b953f69ea6.svg";
export { ForwardRef as ReactComponent };